// extracted by mini-css-extract-plugin
export default {"heading":"BannerSetting_heading__yWpPk","wrapper":"BannerSetting_wrapper__nj5dM"};